// import ApiUrlConfiguration from 'src/ApiUrlConfiguration'

// const PROTOCOL = ApiUrlConfiguration.PROTOCOL
// const HOST = ApiUrlConfiguration.HOST
// const PORT = ApiUrlConfiguration.port.TCAL_VS_VOYAGE
const COMMON_URL = `${process.env.REACT_APP_VOYAGE_ORIGIN_URL}/calista-logistic-ng-app-main/vs`

const TcalVsVoyageApiUrls = {
  GET: `${COMMON_URL}/tcal-vs-voyage/hdr/get`,
  POST: `${COMMON_URL}/tcal-vs-voyage/hdr/create`,
  PUT: `${COMMON_URL}/tcal-vs-voyage/hdr/update`,
  DELETE: `${COMMON_URL}/tcal-vs-voyage/hdr/delete`,
  EXPORT: `${COMMON_URL}/tcal-vs-voyage/hdr/download`
}

export default TcalVsVoyageApiUrls
